import CityPageTemplate from "@/components/site/CityPageTemplate";

export default function FinanzberatungWiesbaden() {
  return (
    <CityPageTemplate
      city="Wiesbaden"
      slug="wiesbaden"
      intro="In der hessischen Landeshauptstadt Wiesbaden setzen wir auf transparente, unabhängige Finanzberatung."
      description="Unabhängige & digitale Finanzberatung für Wiesbaden: Altersvorsorge, ETF, Steueroptimierung und staatliche Förderungen. Kostenlose Erstberatung – 100% digital."
    />
  );
}
